import apiService from './apiService';

export const companyService = {
    create: (data) => apiService.post('/companies', data),
    getAll: () => apiService.get('/companies'),
    getActive: () => apiService.get('/companies'),
    getByBusinessScope: (scope) => apiService.get(`/companies/business-scope/${scope}`),
    getById: (id) => apiService.get(`/companies/${id}`),
    update: (id, data) => apiService.put(`/companies/${id}`, data),
    toggleStatus: (id) => apiService.patch(`/companies/${id}/toggle-status`),
    delete: (id) => apiService.delete(`/companies/${id}`)
};
